import { render, staticRenderFns } from "./footer-basic.vue?vue&type=template&id=1c082709&"
import script from "./footer-basic.vue?vue&type=script&lang=ts&"
export * from "./footer-basic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports